export enum Routes {
  subscription = '/podpiska/',
}
